import React, { Fragment } from "react";
import arrows from "../../../../../../Assets/Images/arrows.svg";
import "./style.css";

const Table = ({ data }) => {

  return (
    <Fragment>
      <h2>Activities</h2>
      <div className="view-card-table table mb-0 pt-2">
        <table className="table border mb-0 border-top-0">
          <thead className="heading">
            <tr className="hdng-row border-bottom-0">
              <th className="text-start px-3">
                Category <img src={arrows} alt="arrows" />
              </th>
              <th className="text-center px-3">
                Score <img src={arrows} alt="arrows" />
              </th>
              <th className="text-center px-3">
                Submissions <img src={arrows} alt="arrows" />
              </th>
              <th className="text-center px-3">
                Attempts <img src={arrows} alt="arrows" />
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              return (<tr kye={index}>
                <td className="text-start">{item?.category_name}</td>
                <td className="text-center">{Math.ceil(item?.percentage)}%</td>
                <td className="text-center">{item?.total_submissions}</td>
                <td className="text-center">{item?.total_attempts}</td>
              </tr>)
            })}
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};

export default Table;
